import { NavLink } from 'react-router-dom'
import { useSelector } from 'react-redux'

import { Tooltip } from 'antd'
import styled from 'styled-components'

import { colours } from '@qflow/theme'

import { SideBar, icons } from 'portal/lib/primitives'

export function HomepageSidebarButton({ homepageUri }) {
  const isCollapsed = useSelector(state => state.ui.data.sidebarCollapsed)

  return isCollapsed ? (
    <Tooltip title="Home" placement="right">
      <StyledNavLink id="HomepageSideBarButton" to={homepageUri}>
        <icons.Home colour="currentColor" />
      </StyledNavLink>
    </Tooltip>
  ) : (
    <SideBar.NavButton
      id="HomepageSideBarButton"
      to={homepageUri}
      Icon={icons.Home}
      noWrapper={true}
      minimalMargin={true}
    >
      Home
    </SideBar.NavButton>
  )
}

const StyledNavLink = styled(NavLink)`
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: transparent;
  border-radius: 6px;
  margin: -0.5rem -0.25rem 0;
  padding: 8px;
  width: 34px;
  color: #ffffff;
  opacity: 0.8;

  &:hover:not(.active) {
    opacity: 1;
    color: #ffffff;
  }

  &.active {
    color: ${colours.TEAL};
    background-color: rgba(255, 255, 255, 0.1) !important;
    opacity: 1;
  }
`
